import React, { useEffect, useState } from "react";
import {
  Navbar,
  Container,
  NavbarBrand,
  Modal,
  ModalBody,
  Button,
} from "reactstrap";
import Logo from "../../assets/img/custom/logo.png";
import { useDispatch, useSelector } from "react-redux";
import { logout, switchLayout } from "../../store/actions/authActions";
import { FaBell } from "react-icons/fa";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom";
import { getUnreadNotifications } from "store/actions/notificationsAction";
import AthletePromotionModal from "../Modals/AthletePromotionModal";

const AdminNavbar = (props) => {
  const [logoutModal, setLogoutModal] = useState(false);
  const [showDot, setShowDot] = useState(false);
  const [selfBoostModal, setSelfBoostModal] = useState(false);

  const { isManager, user, uid } = useSelector((state) => state.auth);
  const { unreadNotifications } = useSelector((state) => state.notifications);
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const logoutToggle = () => setLogoutModal((v) => !v);
  const toggleSelfBoostModal = () => setSelfBoostModal((v) => !v);

  useEffect(() => {
    if (user?.id) {
      dispatch(getUnreadNotifications(user.id, "", () => {}));
    }
  }, []);

  useEffect(() => {
    if (
      location.pathname !== "/fan/notifications" &&
      unreadNotifications?.length > 0
    ) {
      setShowDot(true);
    }
  }, [unreadNotifications, location.pathname]);

  useEffect(() => {
    if (location.pathname === "/fan/notifications") {
      setShowDot(false);
    }
  }, [location.pathname]);

  const handleBellClick = () => {
    setShowDot(false);
    history.push("/fan/notifications");
  };

  return (
    <>
      {/* Desktop only — hidden on mobile */}
      <Navbar
        className="navbar-top bg-white d-none d-lg-flex"
        expand="lg"
        id="navbar-main"
        style={{ top: props.maxLimitReached ? "30px" : "0px" }}
      >
        <NavbarBrand
          className="pt-0"
          href="https://fans-help-players-athlete.web.app/"
        >
          <img className="mx-2" alt="Logo" src={Logo} height="70px" />
        </NavbarBrand>
        <Container fluid>
          <div className="mx-auto"></div>
          <div
            onClick={handleBellClick}
            className="position-relative mr-4"
            style={{ cursor: "pointer" }}
          >
            <FaBell size={24} className="text-dark" />
            {showDot && (
              <span
                className="position-absolute bg-danger rounded-circle blinking-dot"
                style={{
                  width: "10px",
                  height: "10px",
                  top: "-5px",
                  right: "-5px",
                  zIndex: 1,
                }}
              ></span>
            )}
          </div>
          <div className="d-flex align-items-center flex-nowrap">
            {(user?.isManager && (user?.managerCertified || user?.certifiedFromExternalPlatform)) && (
              <>
                <Button
                  className="ml-auto bg-transparent border-0"
                  onClick={toggleSelfBoostModal}
                >
                  Self Boost
                </Button>
                <Button
                  className="ml-auto bg-transparent border-0"
                  onClick={() => dispatch(switchLayout(!isManager))}
                >
                  {isManager ? "Fan" : "Manager"}
                </Button>
              </>
            )}
            <Button
              tag="a"
              href="mailto:FansHelpPlayers@gmail.com"
              className="ml-auto bg-transparent border-0"
              style={{ textDecoration: "none" }}
            >
              Report a Problem
            </Button>
            <Button
              className="ml-auto bg-transparent border-0"
              onClick={logoutToggle}
            >
              Logout
            </Button>
          </div>
        </Container>
      </Navbar>

      <Modal isOpen={logoutModal} centered toggle={logoutToggle}>
        <ModalBody>
          <div className="text-center">
            <i
              className="fa fa-sign-out-alt text-primary"
              style={{ fontSize: 70 }}
            ></i>
            <br /><br />
            <span className="mt-5" style={{ fontSize: 30 }}>Are you sure?</span>
            <br /><br />
            <span className="mt-5" style={{ fontSize: 16 }}>You want to logout.</span>
            <br /><br /><br />
            <Button color="danger" onClick={logoutToggle}>Cancel</Button>{" "}
            <Button color="primary" onClick={() => dispatch(logout())}>Logout</Button>
          </div>
        </ModalBody>
      </Modal>

      <AthletePromotionModal
        isOpen={selfBoostModal}
        onClose={toggleSelfBoostModal}
        athlete={{
          id: uid,
          name:
            user?.name ||
            `${user?.first_name || ""} ${user?.last_name || ""}`.trim() ||
            "Your Name",
          email: user?.email || "",
          sport: user?.sport || "",
          profileImage: user?.photo || user?.photoURL,
        }}
        type="selfBoost"
      />
    </>
  );
};

export default AdminNavbar;
